import { useEffect, useState } from "react"
import Header from "../../Components/Header/Header"
import Footer from "../../Components/Footer/Footer"
import ContactsBar from "../../Components/ContactsBar/ContactsBar"
import Offer from "../../Models/Offer"
import API from "../../Services/API"
import "./OfferDetailsView.css"
import { useParams } from "react-router-dom";
import DetailsTitleBar from "../../Components/DetailsTitleBar/DetailsTitleBar"
import DetailsProduct from "../../Components/DetailsProduct/DetailsProduct"
import DetailsOption from "../../Components/DetailsOption/DetailsOption"
import OfferProducts from "../../Models/OfferProducts"
import ServicesForm from "../../Components/ServicesForm/ServicesForm"
import { PackageAdType } from "../../Enums/PackageAdType"
import { PackageCustomerType } from "../../Enums/PackageCustomerType"
import { PackageType } from "../../Enums/PackageType"

const OfferDetailsView = () => {
	let { id } = useParams()
	let { customerType } = useParams()
	let [offerProducts, setOfferProducts] = useState<OfferProducts[]>([])
	let [offerOptions, setOfferOptions] = useState<OfferProducts[]>([])
	let [offer, setOffer] = useState<Offer | undefined>(undefined)
	let [vatLine, setVatLine] = useState<string>("")

	useEffect(() => {
		(async () => {
			let packageRes = await API.getPackage(id!, getCustomerTypeIdFromEnum())
			if (packageRes.success) {
				setOffer(packageRes.data)
			}

			let productRes = await API.getPackageProductsAsync(id!)
			if (productRes.success) {

				productRes.data.sort((a,b) => {
					if (!a.order) return 1
					if (!b.order) return -1
					return a.order - b.order
				})

				setOfferProducts(productRes.data.filter(x => x.type === PackageAdType.First))
				setOfferOptions(productRes.data.filter(x => x.type === PackageAdType.Second))
			}
			setVatLine(customerType === PackageCustomerType.Private ? "Iva inclusa" : "Iva esclusa")
		})()
		return () => { };
	}, [])

	function getServicesForm() {
		if (customerType !== PackageCustomerType.Private) {
			return <ServicesForm></ServicesForm>
		}
	}

	function getInfoButton() {
		if (customerType !== PackageCustomerType.Private) {
			return <a className='details-options-blue-link' href={`${process.env.REACT_APP_SITE_URL}/contatti/`}>
				<button className='details-options-purple-button'>
					Richiedi Informazioni
				</button>
			</a>
		}
	}

	function getPriceInfoButton() {
		if (customerType !== PackageCustomerType.Private) {
			return <a className='details-price-purple-link' href={`${process.env.REACT_APP_SITE_URL}/contatti/`}>
				<button className='details-options-purple-tall-button'>
					Richiedi Informazioni
				</button>
			</a>
		}
	}

	function getPromoImage(){
		if (offer?.package_type === PackageType.Promo) {
			return <img className="details-promo-image" alt='' src='/assets/cockade.png' />
		}
	}

	function getCustomerTypeIdFromEnum(): number {
		if (customerType === PackageCustomerType.Private) {
			return 1
		}
		else if (customerType === PackageCustomerType.Professional) {
			return 2
		}
		else {
			return 3
		}
	}

	return (
		<div>
			<Header></Header>
			<DetailsTitleBar title={offer?.ad_title} imageSrc={offer?.image_url} backgroundColor={offer?.background_color ?? "white"} ></DetailsTitleBar>
			<div className="details-price-container">
				<div className="details-price-column">
					<div className="details-price-start">a partire da</div>
					<div className="details-price">{offer?.ad_price}</div>
					<div className="details-vat">{vatLine}</div>
					{getPriceInfoButton()}
					{getPromoImage()}
				</div>

				<div className="details-products-column">
					{offerProducts.map(x => <DetailsProduct key={x.id} imageSrc={x.icon} title={x.title} description={x.description}></DetailsProduct>)}
				</div>
			</div>

			<div className="details-options-container">
				<div className="details-additional-services">Servizi aggiuntivi e opzionali</div>
				<div className="details-options-list">
					<div className="details-grid">
						{offerOptions.map(x => <DetailsOption key={x.id} imageSrc={x.icon} title={x.title} description={x.description}></DetailsOption>)}
					</div>
				</div>
				<div className="details-link-row">
					<a className='details-options-blue-link' href={`${process.env.REACT_APP_SITE_URL}/servizi/`}>
						<button className='details-options-blue-button'>
							Scopri i nostri servizi
						</button>
					</a>
					{getInfoButton()}
				</div>
			</div>
			{getServicesForm()}
			<ContactsBar></ContactsBar>
			<Footer></Footer>
		</div>
	)
}

export default OfferDetailsView